import { v4 as uuidv4 } from 'uuid';
import {
  ExactLocation,
  JobRequirement,
  LocationRegion,
  LocationRegionsResponse,
  Position,
  PositionLocations,
  PositionSkill,
} from '../../@types/position';

export const PositionTransformer = {
  addIdsToRegions(regions?: LocationRegion[]): LocationRegion[] {
    return regions?.map((region) => ({
      id: uuidv4(),
      country: region.country,
      countryLong: region.countryLong,
      region: region.region,
    })) || [];
  },

  addIdsToExactLocations(exactLocations?: ExactLocation[]): ExactLocation[] {
    return exactLocations?.map((item) => ({
      id: uuidv4(),
      country: item.country,
      countryLong: item.countryLong,
      city: item.city,
      state: item.state,
      stateLong: item.stateLong,
      geometry: item.geometry,
      locationMileRadius: item.locationMileRadius,
    })) || [];
  },

  addIdsToLocations(locations: PositionLocations): PositionLocations {
    if (!locations) {
      return locations;
    }

    return {
      regions: this.addIdsToRegions(locations.regions),
      exactLocations: this.addIdsToExactLocations(locations.exactLocations),
    };
  },

  addIdsToSkills(skills: PositionSkill[]): PositionSkill[] {
    if (!skills?.length) {
      return skills;
    }

    return skills.map((skill) => {
      return {
        ...skill,
        id: skill.id || uuidv4(),
      };
    });
  },

  addIdsToCompanyBackground(companyBackground: JobRequirement[] | undefined): JobRequirement[] | undefined {
    if (!companyBackground?.length) {
      return companyBackground;
    }

    return companyBackground.map((cb) => {
      return {
        ...cb,
        id: cb.id || uuidv4(),
      };
    });
  },

  formatInputParamsResponse(data: Position): Position {
    return {
      ...data,
      locations: this.addIdsToLocations(data.locations),
      skills: this.addIdsToSkills(data.skills),
    };
  },

  locationRegionsResponseToLocationRegions(data: LocationRegionsResponse): LocationRegion[] {
    return data?.regions?.map((reg) => {
      return {
        region: reg.name,
        country: reg.country,
        countryLong: reg.countryLong,
        id: uuidv4(),
      };
    });
  },
};
